export const DATE_FORMAT_ISO_8601 = 'YYYY-MM-DD'
export const DATE_TIME_FORMAT_ISO_8601 = 'YYYY-MM-DD HH:mm:ss'
export const DATE_FORMAT = 'DD MMM YYYY'
export const DATE_TIME_FORMAT = 'DD MMM YYYY, HH:mm'
export const DATE_TIME_SECOND_FORMAT = 'DD MMM YYYY HH:mm:ss'
